const getShortenEmail = (fullEmail: string, length = 8): string => {
  if (fullEmail.length < 15) return fullEmail;

  const emailArr = fullEmail.split('@');
  const emailNamePart =
    emailArr[0].length > length ? `${emailArr[0].substring(0, length)}...` : emailArr[0];

  return `${emailNamePart}@${emailArr[1]}`;
};

export default getShortenEmail;
